module.exports = __webpack_public_path__ + "img/icon_tangchuang2.d3aa2c6a.png";